<a (click)="handleMainMenuAction()" class="nav-link" [ngClass]="{active: isMainActive || isOneOfChildrenActive}"
    *ngIf="menuItem.permission">
    <i class="nav-icon {{ menuItem.iconClasses }}"></i>
    <p class="menu-item-text">
        {{ menuItem.name }}
        <span *ngIf="menuItem.hasNotification" class="notification-dot"></span>

        <i *ngIf="isExpandable && menuItem.children.length > 0" class="right fas fa-angle-right"
            [@rotate]="isMenuExtended"></i>
    </p>

</a>

<ul class="nav nav-treeview" *ngFor="let item of menuItem.children" [@openClose]="isMenuExtended">
    <li class="nav-item">
        <a [routerLink]="item.path" [routerLinkActive]="'active'" class="nav-link" *ngIf="menuItem.permission">
            <i class="nav-icon {{ item.iconClasses }}"></i>
            <p class="menu-item-text">
                {{ item.name }}
                <span *ngIf="item.hasNotification" class="notification-dot"></span>
            </p>

        </a>
    </li>
</ul>